import React from 'react'
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './EmptyInbox.css';

// Locale
import messages from '../../../locale/messages';

//Image
import noInboxImage from '/public/SiteImages/noInboxImage.svg';

const EmptyInbox = ({ type }) => {
  return (
    <div className={s.textCenter}>
      <img src={noInboxImage} className={s.widthImg} />
      <p className={s.textMuted}>
        <FormattedMessage {...messages[type === 'guest' ? 'noMessagesTitle1' : 'noMessagesTitle2']} />
      </p>
    </div>
  );
}

export default withStyles(s)(EmptyInbox);
